exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.recycle {\n    background-color: #979798;\n}\n", ""]);

// exports
